import * as React from "react";
import { NavLink, Route, Switch } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { VingleURL } from "@vingle/wtf-sdk/url";
import { VingleRedirect } from "@vingle/wtf-sdk/components/vingleRedirect";
import ProfileEdit from "./edit";
import {
  PrivilegeInterestsOfPersonaGrata,
  PrivilegeInterestsOfPersonaNonGrata,
} from "./privilegeInterests";

const styles = require("./account.scss");

function AccountPage() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.leftMenuWrapper}>
        <NavLink
          to={new VingleURL.AccountEditProfile().toString()}
          className={styles.menuItem}
          activeClassName={styles.active}
        >
          <FormattedMessage id="user_edit.account_settings" />
        </NavLink>
        <NavLink
          to={new VingleURL.AccountPrivilegeInterestsOfPersonaGrata().toString()}
          className={styles.menuItem}
          activeClassName={styles.active}
        >
          <FormattedMessage id="account.privilege.pg.name" />
        </NavLink>
        <NavLink
          to={new VingleURL.AccountPrivilegeInterestsOfPersonaNonGrata().toString()}
          className={styles.menuItem}
          activeClassName={styles.active}
        >
          <FormattedMessage id="account.privilege.png.name" />
        </NavLink>
      </div>
      <div className={styles.rightMenuWrapper}>
        <Switch>
          <Route
            path={VingleURL.AccountEditProfile.pattern}
            component={ProfileEdit}
          />
          <Route
            path={VingleURL.AccountPrivilegeInterestsOfPersonaGrata.pattern}
            component={PrivilegeInterestsOfPersonaGrata}
          />
          <Route
            path={VingleURL.AccountPrivilegeInterestsOfPersonaNonGrata.pattern}
            component={PrivilegeInterestsOfPersonaNonGrata}
          />
          <VingleRedirect to={new VingleURL.AccountEditProfile()} />
        </Switch>
      </div>
    </div>
  );
}

export default React.memo(AccountPage);
